import { Commit } from 'vuex'
import { MENU_TYPE } from '@/model/components/menu/sideMenuType'
import { ErrorMsgState } from '@/model/components/common/message/errorMessage'
import { i18n, localStorageKey } from '@/i18n'
import { LANG_TYPE } from '@/i18n/langType'
import ACTION_TYPE from './actionTypes'
import MUTATION_TYPE from './mutationTypes'
import * as StateType from './state'
import * as Screen from './stateScreen'

// actions定義
const actions = {
  /**
   * ログイン認証情報設定処理
   * @param param0 commitオブジェクト
   * @param payload 入力データ
   */
  [ACTION_TYPE.LOGIN_AUTH]({ commit }: { commit: Commit }, payload: StateType.Login) {
    // mutationの認証情報設定処理呼び出し
    commit(MUTATION_TYPE.SET_LOGIN_AUTH, payload)
  },
  /**
   * ログイン処理
   * @param param0 commitオブジェクト
   */
  [ACTION_TYPE.LOGIN_INFO]({ commit }: { commit: Commit }) {
    // mutationのログイン設定処理呼び出し
    commit(MUTATION_TYPE.SET_LOGIN)
  },
  /**
   * ログイン前初期処理
   * @param param0 commitオブジェクト
   */
  [ACTION_TYPE.LOGIN_BEFORE_INIT]({ commit }: { commit: Commit }) {
    // mutationのログイン後データのクリア処理呼び出し
    commit(MUTATION_TYPE.CLEAR_DOWNLOAD_DETAIL)
    commit(MUTATION_TYPE.CLEAR_DOWNLOAD_NODATA)
  },
  /**
   * TOP画面遷移処理
   * @param param0 commitオブジェクト
   * @param payload  入力データ
   */
  [ACTION_TYPE.TOP_REDIRECT]({ commit }: { commit: Commit }, payload: Screen.Top) {
    // mutationのTOP処理呼び出し
    commit(MUTATION_TYPE.SET_TOP, payload)
  },
  // ログアウト処理(初期処理)
  [ACTION_TYPE.LOGOUT]({ commit }: { commit: Commit }) {
    // mutationのログイン情報関連をクリア
    commit(MUTATION_TYPE.CLEAR_LOGIN_AUTH)
    commit(MUTATION_TYPE.CLEAR_LOGIN)
    commit(MUTATION_TYPE.CLEAR_TOP_AUTH)
    commit(MUTATION_TYPE.CLEAR_DOWNLOAD_DETAIL)
    commit(MUTATION_TYPE.CLEAR_DOWNLOAD_NODATA)
  },
  /**
   * メニュー情報設定処理
   * @param param0 commitオブジェクト
   * @param payload メニュー種別
   */
  [ACTION_TYPE.MENU_SET]({ commit }: { commit: Commit }, payload: MENU_TYPE) {
    // mutationのメニュー情報設定
    commit(MUTATION_TYPE.MENU_SET, payload)
  },
  /**
   * ダウンロード検索情報設定
   * @param param0 commitオブジェクト
   * @param payload ダウンロード詳細情報
   */
  [ACTION_TYPE.DOWNLOAD_SET]({ commit }: { commit: Commit }, payload: Screen.DonwloadDetail) {
    // mutationのダウンロード詳細情報設定
    commit(MUTATION_TYPE.SET_DOWNLOAD_DETAIL, payload)
  },
  /**
   * ダウンロード検索情報クリア
   * @param param0 commitオブジェクト
   */
  [ACTION_TYPE.DOWNLOAD_CLEAR]({ commit }: { commit: Commit }) {
    // mutationのダウンロード詳細情報クリア
    commit(MUTATION_TYPE.CLEAR_DOWNLOAD_DETAIL)
    // mutationのダウンロードデータ無しデータのクリア
    commit(MUTATION_TYPE.CLEAR_DOWNLOAD_NODATA)
  },
  /**
   * ダウンロードエラー情報設定
   * @param param0 commitオブジェクト
   * @param payload エラー情報
   */
  [ACTION_TYPE.DOWNLOAD_ERROR_SET]({ commit }: { commit: Commit }, payload: ErrorMsgState) {
    // mutationのダウンロード詳細情報クリア
    commit(MUTATION_TYPE.CLEAR_DOWNLOAD_DETAIL)
    // mutationのダウンロードデータ無しデータの設定
    commit(MUTATION_TYPE.SET_DOWNLOAD_NODATA, payload)
  },
  /**
   * 言語切り替え
   * @param param0 commitオブジェクト
   * @param payload 言語
   */
  [ACTION_TYPE.LANGCHANGE_SET]({ commit }: { commit: Commit }, payload: LANG_TYPE) {
    // mutationの言語情報設定処理
    commit(MUTATION_TYPE.LANGCHANGE, payload)
    // ローカルストレージに反映
    localStorage.setItem(localStorageKey, payload)
    // i18nのlangに設定
    i18n.global.locale = payload
  },
  /**
   * ヘッダー情報クリア
   * @param param0 commitオブジェクト
   */
  [ACTION_TYPE.HEADER_CLEAR]({ commit }: { commit: Commit }) {
    // mutationのヘッダー情報クリア
    commit(MUTATION_TYPE.CLEAR_HEADER)
  },
  /**
   * 他画面情報の設定
   * @param param0 commitオブジェクト
   */
  [ACTION_TYPE.OTHER_SET]({ commit }: { commit: Commit }) {
    // mutationの他画面情報の設定
    commit(MUTATION_TYPE.SET_OTHER)
  },
}

export { actions }
